import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { PendingExitApprovalModel } from 'src/app/models/PendingExitApprovalModel';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { ConfirmExitClearanceWithToken } from 'src/app/models/ConfirmExitClearanceWithDto';
import { SharedService } from 'src/app/services/shared.service';
import { TokenService } from 'src/app/services/token.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-confirm-clearance',
  templateUrl: './confirm-clearance.component.html',
  styleUrls: ['./confirm-clearance.component.css']
})
export class ConfirmClearanceComponent implements OnInit {
  exitClearance: PendingExitApprovalModel | null = null;
  confirmDto: ConfirmExitClearanceWithToken | any;
  hasUserApprovedContract:boolean=false;
  UpdateRequest:any;

  waiverReason: string = "";
  showMedicalWaiverPrompt = false;
  showWaiverModal = false;
  responseMessage: string = "";
  Token: string = "";
  constructor(private route: ActivatedRoute, private _ActivatedRoute: ActivatedRoute,
    private exitClearanceService: ExitClearanceService,
    private notification: NotificationService,
    private router: Router,private location:Location , private sharedService: SharedService, private tokenService: TokenService) { }

    ngOnInit(): void {
      
      this.route.queryParams.subscribe(params => {
        this.Token = params['to'];
        console.log('Token:', this.Token);
      });

        this.LoadData();
      this.location.replaceState(this.location.path().split('?')[0], '');
        
      var snapshot = this._ActivatedRoute.snapshot;
      const params = { ...snapshot.queryParams };
      delete params.pos
      this.router.navigate([], { queryParams: params });

      // });
    }
  
     async LoadData()
      {
        
        let resLo = await this.exitClearanceService.BeginApproval(this.Token).toPromise();
        var payload  = <ConfirmExitClearanceWithToken>resLo.responseData;
        this.exitClearance = payload.pendingExitApprovalModel;
        
        // console.log(payload.pendingExitApprovalModel)
        if(payload.hasUserApprovedContract)
        {
          this.hasUserApprovedContract = true;
        }
        this.UpdateRequest = payload.pendingExitApprovalModel;
        window.localStorage.clear();
        // store token
        this.exitClearance=payload.pendingExitApprovalModel;
        this.sharedService.loginResponseData = payload.login;
        this.tokenService.saveSession(payload.login);
        this.tokenService.setInfo(payload.login);

        const medicalApproval = this.exitClearance?.approvals.find(
          x => x.checklistId === 5 && x.status === 'Pending'
        );

        this.showMedicalWaiverPrompt =
          !this.exitClearance?.exitClearance.needMedicalWaiver &&
          !!medicalApproval;
        
      }


    async handleSubmit() {
      let id = this.exitClearance?.exitClearance.id;
      if(id)
      this.exitClearanceService.SendReminderByEmployee(id).subscribe(
        (response) => {
          if (response.responseCode == "00") {
            this.notification.sendMessage({
              message: response.message,
              type: NotificationType.success
            });

        }
      })

    }

    async approveExitClearance(){
      ;
      const request = { Token: this.Token };
      if (this.Token) {
        this.exitClearanceService.confirmClearanceWithToken(request).subscribe(
          (response: any) => {
            ;
            this.responseMessage = response.message;

            this.notification.sendMessage({
              message: this.responseMessage,
              type: NotificationType.success
            });
            this.LoadData();
          },
          (error) => {
            this.notification.sendMessage({
              message: this.responseMessage,
              type: NotificationType.error
            });
          }
        );
      }
    } 
    submitWaiver() {

      this.SendDrEmpOption();

      this.showWaiverModal = false;
      this.showMedicalWaiverPrompt = false;

    }
   async SendDrEmpOption() {

  const request = { Token: this.Token };

  this.exitClearanceService
      .UpdateWaiverRequest(request, this.waiverReason)
      .subscribe({
          next: (response: any) => {

              this.notification.sendMessage({
                  message: response.message,
                  type: NotificationType.success
              });

              this.showWaiverModal = false;
              this.showMedicalWaiverPrompt = false;

              this.LoadData();
          },
          error: (error) => {

              this.notification.sendMessage({
                  message: error.error?.message ?? 'An error occurred.',
                  type: NotificationType.error
              });

          }
      });
}

}